// client/src/pages/sections/groups/useSubmitGuard.js
// One submit at a time per dialog. The Client Groups dialogs close the moment Confirm is clicked and finish in the
// background (optimistic), so nothing on screen says "already sent": a double-click inside one frame, or a second click
// while the answer is still on its way, posted the same action twice. Wrap the dialog's submit:
//
//   const guard = useSubmitGuard();
//   <button onClick={() => guard(submit)}>
//
// A call made while the previous one has not finished is ignored. The guard is released when `submit` settles, however
// it ends (a validation error returns at once, so the partner can fix it and click again).
// resolveActionQueue.js is the second line of defence: it never sends the same request twice at the same time.

import { useCallback, useRef } from 'react';

export function useSubmitGuard() {
  const busy = useRef(false);
  return useCallback(async (fn) => {
    if (busy.current) return undefined;
    busy.current = true;
    try {
      return await fn();
    } finally {
      busy.current = false;
    }
  }, []);
}
